import { useTheme } from "@mui/material";
import { createSxStyles } from "../../../common/createSxStyles";

export const settingsBarWidth = 250;

export const useSettingsBarStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            width: settingsBarWidth,
            minWidth: settingsBarWidth,
            position: "relative",
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.05)",
            backgroundColor: theme.customPalette.collapseBackground,
            borderTopLeftRadius: theme.spacing(2),
            marginLeft: -2,
            marginTop: -2,
            marginBottom: -2,
        },
        header: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingBottom: theme.spacing(2),
            color: theme.palette.primary.dark,
            fontWeight: "bold",
            fontSize: theme.typography.pxToRem(16),
        },
        section: {
            marginBottom: theme.spacing(2),
        },
        sectionHeader: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(1),
            color: theme.palette.primary.dark,
            fontSize: theme.typography.pxToRem(13),
            fontWeight: "bold",
            textTransform: "uppercase",
        },
        menuItem: {
            display: "block",
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(0.75),
            paddingBottom: theme.spacing(0.75),
            fontSize: theme.typography.pxToRem(12),
            color: theme.palette.primary.dark,
            textDecoration: "none",
            cursor: "pointer",
            borderLeft: "3px solid transparent",
            "&:hover": {
                color: theme.palette.primary.main,
            },
        },
        activeMenuItem: {
            borderLeft: `3px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            fontWeight: "bold",
        },
    });
};
